var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZipperHood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 281 66.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hood_zipper",
    "data-name": "hood zipper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.18,58.06H195a19.1,19.1,0,0,0-7.33,1.46c-7.64,3.14-15.23,6.64-24.05,9.53a21.51,21.51,0,0,1-6.58,1H126.84a21.6,21.6,0,0,1-6.58-1c-8.82-2.89-16.41-6.39-24.05-9.53a19,19,0,0,0-7.33-1.46H1.69c-.61-4.64,37.54-25.38,71-34a7,7,0,0,0,3.61-2.28c5.84-7,11.58-13.34,16.91-16.55a7.42,7.42,0,0,1,3.85-1h89.77a7.38,7.38,0,0,1,3.84,1c5.33,3.21,11.08,9.51,16.92,16.55a7,7,0,0,0,3.62,2.28C244.63,32.68,282.78,53.42,282.18,58.06Z",
    transform: "translate(-1.43 -3.96)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.05,14.06c36.67-9.48,73.36-9.95,110.07,0,6.21,10.14-49,49-49,49-3.91,3.8-8.17,3.31-12.66,0C135.46,63.07,78,21.71,87.05,14.06Z",
    transform: "translate(-1.43 -3.96)",
    fill: "#404041",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.39,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipperHood);
export default __webpack_public_path__ + "static/media/zipper-hood.7fbfcf022c63774f3d25079187e682fb.svg";
export { ForwardRef as ReactComponent };